import React, { useState, useCallback } from 'react'
import { Field, HStack, Input, Text } from '@chakra-ui/react'
import { validateExpiry } from '../validators/cardValidator'

export const ExpiryDateInput = ({ onChange }) => {
  const [monthValue, setMonthValue] = useState('')
  const [yearValue, setYearValue] = useState('')
  const [error, setError] = useState(null)
  const [touched, setTouched] = useState(false)

  const notifyParent = useCallback(
    (month, year) => {
      const validationError = validateExpiry(month, year)
      if (onChange) {
        onChange({ month, year }, !validationError)
      }
    },
    [onChange],
  )

  const handleMonthChange = useCallback(
    (e) => {
      const newValue = e.target.value.replace(/\D/g, '')
      if (newValue.length <= 2) {
        setMonthValue(newValue)
        // エラーがある場合のみクリア
        if (error) {
          setError(null)
        }
        notifyParent(newValue, yearValue)
      }
    },
    [error, yearValue, notifyParent],
  )

  const handleYearChange = useCallback(
    (e) => {
      const newValue = e.target.value.replace(/\D/g, '')
      if (newValue.length <= 2) {
        setYearValue(newValue)
        // エラーがある場合のみクリア
        if (error) {
          setError(null)
        }
        notifyParent(monthValue, newValue)
      }
    },
    [error, monthValue, notifyParent],
  )

  const handleBlur = useCallback(() => {
    // 月が1桁の場合はゼロ埋め
    let finalMonth = monthValue
    if (monthValue.length === 1) {
      finalMonth = monthValue.padStart(2, '0')
      setMonthValue(finalMonth)
    }

    setTouched(true)
    const validationError = validateExpiry(finalMonth, yearValue)
    setError(validationError)
    notifyParent(finalMonth, yearValue)
  }, [monthValue, yearValue, notifyParent])

  return (
    <Field.Root invalid={touched && !!error}>
      <Field.Label fontSize="xs" fontWeight="600" mb="8px" color="externalPayment.cardInputText">
        有効期限
      </Field.Label>
      <HStack gap={2}>
        <Input
          type="text"
          value={monthValue}
          onChange={handleMonthChange}
          onBlur={handleBlur}
          placeholder="月"
          bg="bg.secondary"
          borderRadius="4px"
          h="40px"
          fontSize="3xs"
          fontWeight="300"
          inputMode="numeric"
          maxLength={2}
          w="72px"
          borderWidth="1px"
          borderColor="externalPayment.cardInputBorder"
          _placeholder={{ color: 'externalPayment.cardInputPlaceholder' }}
          _hover={{ borderColor: 'externalPayment.cardInputBorderHover' }}
          _focus={{ borderColor: 'externalPayment.cardInputBorderFocus', boxShadow: 'none' }}
        />
        <Text fontSize="2xs" fontWeight="400" color="externalPayment.cardInputText">
          /
        </Text>
        <Input
          type="text"
          value={yearValue}
          onChange={handleYearChange}
          onBlur={handleBlur}
          placeholder="年"
          bg="bg.secondary"
          borderRadius="4px"
          h="40px"
          fontSize="3xs"
          fontWeight="300"
          inputMode="numeric"
          maxLength={2}
          w="72px"
          borderWidth="1px"
          borderColor="externalPayment.cardInputBorder"
          _placeholder={{ color: 'externalPayment.cardInputPlaceholder' }}
          _hover={{ borderColor: 'externalPayment.cardInputBorderHover' }}
          _focus={{ borderColor: 'externalPayment.cardInputBorderFocus', boxShadow: 'none' }}
        />
      </HStack>
      {touched && error && <Field.ErrorText>{error}</Field.ErrorText>}
    </Field.Root>
  )
}
